import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { devicesList } from '../api/audio';
import './AudioPlaylists.scss';

export default function AudioPlaylistList() {
    const [devices, setDevices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState(null);

    useEffect(() => { load(); }, []);
    async function load() {
        setLoading(true);
        setErr(null);
        try {
            const list = await devicesList();
            setDevices(list);
        } catch (e) {
            setErr(e.message || 'Ошибка загрузки');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="a-pl-list">
            <div className="head">
                <h2>Аудио по устройствам</h2>
                <div className="hint">Выберите устройство, чтобы управлять его аудио-плейлистом.</div>
            </div>

            {loading && <div className="loading">Загрузка...</div>}
            {err && <div className="error">{err}</div>}

            {!loading && !err && (
                <div className="grid">
                    {devices.length === 0 ? (
                        <div className="empty">Нет устройств</div>
                    ) : devices.map(d => (
                        <div key={d.id} className="card">
                            <div className="title">Устройство #{d.id}</div>
                            <div className="meta"><span>код: {d.code}</span></div>
                            <div className="actions">
                                <Link to={`/audio-playlists/${d.id}`} className="btn">Открыть плейлист</Link>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
